import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  imageOutermost: {
    width: '100%',
    height: '100%',
    padding: '0px 0px'
  }
});

class UploadOrderStatusImage extends Component {
  constructor() {
    super();
    this.inputRef = React.createRef();
  }

  openFileDialog = () => this.inputRef.current.click();

  handleFileChange = (e) => {
    let files = e.target.files;
    if (files && files[0]) {
      this.props.uploadOrderStatusImage(files, this.props.imageKey);
      e.target.value = null; // reset input
    }
  };

  render() {
    const { classes, uploadButtonName } = this.props;

    return (
      <Grid>
        <Grid className={classes.imageOutermost}>
          <Button
            variant="contained"
            onClick={this.openFileDialog}
            color="primary"
            component="span"
          >
            {uploadButtonName}
          </Button>

          <input
            ref={this.inputRef}
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={this.handleFileChange}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(UploadOrderStatusImage);
